
export interface DisableDatabaseToggleResult {
    disabled: boolean;
    name: string;
    success: boolean;
    reason: string;
}
